var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Number.isInteger(_vm.product.status))?_c('ProductInfo',{staticClass:"pa-5",attrs:{"product":_vm.product,"id":_vm.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }